import { render, staticRenderFns } from "./viewAttendanceCorrection.vue?vue&type=template&id=1c67297c&"
import script from "./viewAttendanceCorrection.vue?vue&type=script&lang=js&"
export * from "./viewAttendanceCorrection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports